import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  computed,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ControlsOf, FormArray, FormGroup } from '@ngneat/reactive-forms';
import {
  FormForm,
  FormSection,
} from '../../core/models/form-group-mapping.model';
import { Form, FormType } from '../../core/models/form.model';
import { RendererFormsRepository } from '../../core/repositories/renderer-forms.repository';
import { SectionStateService } from '../../core/services/section-state.service';

@Component({
  selector: 'lib-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicFormComponent {
  formGroup = input<FormGroup<ControlsOf<FormForm>>>();
  showAllFollowUps = input<boolean>();
  hideValidation = input<boolean>();
  previewMode = input<boolean>(false);

  form: Signal<Form>;
  sections: Signal<FormGroup<ControlsOf<FormSection>>[]>;
  orderSectionIds: Signal<string[]>;
  FormType = FormType;

  constructor(
    private rendererFormsRepository: RendererFormsRepository,
    private routes: ActivatedRoute,
    private sectionService: SectionStateService,
  ) {
    this.sections = computed(() => {
      const sections = [];
      for (const section of (
        this.formGroup().get('sections') as FormArray<FormSection>
      ).controls) {
        sections[section.value.id] = section as FormGroup<
          ControlsOf<FormSection>
        >;
      }
      return sections;
    });

    this.sectionService.updateStateByRouteParams(
      this.routes.snapshot.queryParams,
    );

    this.form = toSignal(this.rendererFormsRepository.active$);

    const hideSections = this.rendererFormsRepository.getHideSections();
    this.orderSectionIds = computed(() =>
      this.form()?.structure.order.filter((o) => !hideSections?.includes(o)),
    );
  }
}
